import React from "react";
import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function FindUs() {
  return <section id="find-us" className="dark bg-background text-foreground relative w-full h-[600px] lg:h-[700px] overflow-hidden flex flex-col">
      {}
      <div className="absolute inset-0 bg-muted/20">
        {}
        <div className="w-full h-full bg-cover bg-center opacity-60 grayscale-[0.2] contrast-[1.1]" style={{
        backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/map_dark_mode.png)'
      }}>
           {}
           <div className="absolute inset-0 bg-[radial-gradient(#3dc1bc_1px,transparent_1px)] [background-size:40px_40px] opacity-10"></div>
        </div>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-transparent to-background/80 lg:hidden pointer-events-none" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/50 via-transparent to-transparent hidden lg:block pointer-events-none" />

        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center group cursor-pointer">
          <div className="relative flex items-center justify-center">
            <span className="animate-ping absolute inline-flex h-12 w-12 rounded-full bg-primary opacity-75"></span>
            <div className="relative flex items-center justify-center h-12 w-12 rounded-full bg-primary text-primary-foreground shadow-[0_0_20px_rgba(61,193,188,0.6)] transition-transform group-hover:scale-110">
              <MapPin className="h-6 w-6" />
            </div>
          </div>
          <div className="mt-4 px-4 py-2 bg-card/90 backdrop-blur-md border border-border/50 rounded-full shadow-lg text-xs font-bold tracking-wide uppercase text-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-y-2 group-hover:translate-y-0">
            Website Shop HQ
          </div>
        </div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 h-full pointer-events-none flex flex-col justify-end lg:justify-center pb-8 lg:pb-0">
        <div className="w-full max-w-md lg:ml-12 pointer-events-auto space-y-4">
          
          {}
          <Card className="bg-card/80 backdrop-blur-xl border-border/50 shadow-2xl overflow-hidden">
            <CardHeader className="pb-4">
              <div className="flex items-center justify-between">
                <CardTitle className="text-xl font-bold tracking-tight">Local&nbsp; Office&nbsp;</CardTitle>
                <span className="inline-flex items-center justify-center rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary ring-1 ring-inset ring-primary/20">
                  Open Now
                </span>
              </div>
              <CardDescription className="text-muted-foreground">
                Central Coast, Australia
              </CardDescription>
            </CardHeader>
            <CardContent className="grid gap-6">
              <div className="flex items-start gap-4">
                <div className="mt-1 p-2 rounded-lg bg-secondary text-primary">
                  <Clock className="h-5 w-5" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium leading-none text-foreground">Opening Hours</p>
                  <p className="text-sm text-muted-foreground">
                    Monday - Friday: 9am - 5pm AEST
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="mt-1 p-2 rounded-lg bg-secondary text-primary">
                  <Navigation className="h-5 w-5" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium leading-none text-foreground">Location</p>
                  <p className="text-sm text-muted-foreground">
                    Serving all of Central Coast & surrounding areas.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {}
          <Card className="bg-primary text-primary-foreground border-none shadow-[0_0_40px_rgba(61,193,188,0.3)] overflow-hidden relative">
            <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.2)_50%,transparent_75%)] bg-[length:250%_250%] animate-[shimmer_3s_infinite]" />
            <CardContent className="p-6 flex items-center justify-between relative z-10">
              <div className="space-y-1">
                <p className="font-bold text-lg">Ready to start?</p>
                <p className="text-primary-foreground/80 text-sm">Call us for a free quote.</p>
              </div>
              <Button asChild size="lg" className="bg-white text-teal-600 hover:bg-white/90 hover:text-teal-700 font-bold rounded-full shadow-lg transition-all hover:scale-105">
                <Link to="tel:0473462554" className="flex items-center gap-2">
                  <Phone className="h-4 w-4" />
                  <span>Click to Call</span>
                </Link>
              </Button>
            </CardContent>
          </Card>

        </div>
      </div>
    </section>;
}